<template>
  <div class="main-panel">
    <div class="main-title">为了您的账号安全，请绑定密钥，并使用密钥登陆系统</div>
    <div class="content-box">
      <div class="step-box" style="padding-bottom: 30px">
        <div class="step-item">
          <div class="step-icon" style="align-self:flex-end;">
            <span class="el-icon el-icon-mobile-phone"></span>
          </div>
          <div class="step-text">
            下载并安装手机APP:
             <img src="@/assets/images/authenticator.png" style="width:26px;position: relative;top: 7px;" />
            Google Authenticator
          </div>
        </div>
      </div>
      <div class="step-box">
        <div class="step-item">
          <div class="step-icon">
            <span class="el-icon el-icon-full-screen"></span>
          </div>
          <div class="step-text">
            在APP内扫描下方二维码添加账户。如果无法扫描二维码，请输入文本密钥，
            <a @click="toggleTextCode">点击这里</a>
            查看。
          </div>
        </div>
        <el-input v-show="showTextCode" v-model="qr.identitySecret" class="text-input" disabled></el-input>
        <div class="qr-code-box">
          <vue-qr :text="qr.qrCode"></vue-qr>
        </div>
      </div>
      <div class="step-box">
        <div class="step-item">
          <div class="step-icon">
            <span class="el-icon el-icon-coin"></span>
          </div>
          <div class="step-text">
            在下方输入Google Authenticator APP生成的6位动态数字验证码
          </div>
        </div>
        <el-form ref="form" :model="form" label-width="0">
          <el-form-item prop="code" :rules="{ required: true, message: '请输入验证码' }">
            <CodeInput :code="form.code" @complete="handleCodeComplete"  @enter="submit" />
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submit">验证</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import CodeInput from '@/components/common/CodeInput.vue'

export default {
  components: {
    VueQr,
    CodeInput
  },
  props: {
    account: {
      type: Object,
      default: () => {
        return {}
      }
    },
    qr: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showTextCode: false,
      form: {
        code: ''
      }
    }
  },
  methods: {
    toggleTextCode() {
      this.showTextCode = !this.showTextCode
    },
    async submit() {
      const isValid = await this.$refs.form.validate().catch(() => {})
      if (!isValid) {
        return
      }
      const params = {
        code: this.form.code,
        identitySecret: this.qr.identitySecret,
        userAccount: this.$encrypt(this.account.account),
        password: this.$encrypt(this.account.password),
        loginType: this.account.loginType
      }
      this.$service.authLogin(params).then(res => {
        this.$message.success('绑定成功！')
        this.$emit('success', res)
      })
    },
    handleCodeComplete(code) {
      this.form.code = code.join('')
    }
  }
}
</script>

<style lang="stylus" scoped>
.main-panel
  margin 0 auto
  padding 0 20px 20px
  border 1px solid 999
  border-radius 4px
  text-align center
  background-color #fff
  font-family PingFangSC-Regular,PingFang SC
  .main-title
    padding 0 0 30px
    font-size 16px
    font-weight 700
  .content-box
    border 1px solid #f2f2f2
    border-radius 4px
    .qr-code-box
      margin 20px auto 10px
      width 200px
      height 200px
    .step-box
      padding 20px 10px
      border-bottom 1px solid #f2f2f2
      text-align left
      &:last-child
        border-bottom none
      .step-item
        display flex
        flex-flow row nowrap
        .step-icon
          flex-shrink 0
          margin-right 10px
          width 40px
          min-height 28px
          text-align center
          color #999
          .el-icon
            padding-top 4px
            font-size 20px
        .step-text
          font-size 14px
          line-height 28px
          a
            color #408eff
            border-bottom 1px solid #4183c4
            cursor: pointer;
      .text-input
        margin-left 20px
        padding-top 20px
        width calc(100% - 20px)
        >>> .el-inner
          cursor text
    .el-button
      border-radius 4px
      margin 20px 20px 20px 40px
      width calc(100% - 80px)
.el-form-item
  margin 0 10px
  border-bottom 0
  width 100%
  >>>.input-box
    margin-left 40px
    width 100%
  >>>.el-form-item__error
    margin-left 40px
</style>
